import * as mineAlertReducer from "@/reducers/mineAlertReducer";

export const getMineAlerts = (state) => mineAlertReducer.getMineAlerts(state);
export const getGlobalMineAlerts = (state) => mineAlertReducer.getGlobalMineAlerts(state);
